import { graphql, useStaticQuery } from 'gatsby';
import React, { FC } from 'react';

import { keysToCamel } from '@utils/butter';

import Error, { IErrorContent } from './Error.component';

interface IErrorPageProps {
	path: string;
}

const ErrorPage: FC<IErrorPageProps> = ({ path }) => {
	const { pageContent } = useStaticQuery(
		graphql`
			{
				pageContent: butterPage(slug: { eq: "generic-error-page" }) {
					generic_copy
					not_found_copy
				}
			}
		`
	);

	const refinedContent: IErrorContent = keysToCamel(pageContent) as IErrorContent;

	return <Error refinedContent={refinedContent} path={path} />;
};

export { ErrorPage as default };
